module.exports = __webpack_public_path__ + "static/media/hexagan-voilet-tick.58ec69b8.svg";